import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import 'react-bootstrap/dist/react-bootstrap.min.js'


ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js